import { render, staticRenderFns } from "./StatisticPopup.vue?vue&type=template&id=37dcaf4d&scoped=true"
import script from "./StatisticPopup.vue?vue&type=script&lang=js"
export * from "./StatisticPopup.vue?vue&type=script&lang=js"
import style0 from "./StatisticPopup.vue?vue&type=style&index=0&id=37dcaf4d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dcaf4d",
  null
  
)

export default component.exports